import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'PlannedDemandPage',
  //   description: 'description of PlannedDemandPage',
  //   url: '/planned-demand-page',
  // },
];

export default help;
